import { render, staticRenderFns } from "./studentsChoose.vue?vue&type=template&id=6a7d45f7&scoped=true"
import script from "./studentsChoose.vue?vue&type=script&lang=js"
export * from "./studentsChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7d45f7",
  null
  
)

export default component.exports